import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Box, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';
import { set } from 'date-fns';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';
const ElevatorFrontDesk = () => {
  //TODO: elevatorFloor 樓層; ;elevatorDoorOpen 門全開;elevatorDoorClose 門全關;
  //TODO: elevatorUp 上樓顯示狀態; elevatorDown 下樓顯示狀態
  const [FakeDate, setFakeDate] = useState([]);
  const [socketArr, setSocketArr] = useState([]);

  const [elevatorBtnStatus, setElevatorBtnStatus] = useState('');
  const [elevatorDoorStatus, setElevatorDoorStatus] = useState([0, 0]);

  useEffect(() => {
    (async () => {
      try {
        await axios(`/ezcon/api/elevator/status`, {
          method: 'GET',
          headers: { authorization: window.localStorage['feathers-jwt'] },
        });
      } catch (error) {
        console.error('Error fetching elevator data:', error);
      }
    })();
  }, []);
  useEffect(() => {
    // let i = 0;
    client.io.on('elevatorStatus', (arr, callback) => {
      console.log(arr);
      setSocketArr(arr.elevatorStatusList);
      setElevatorDoorStatus((prevStatus) =>
        arr.elevatorStatusList.map((item, index) => {
          if (item.door === 'Opened') return 1;
          if (item.door === 'Closed') return 0;
          return prevStatus[index]; // 確保取到最新的狀態值
        })
      );
      setElevatorBtnStatus(arr.lightStatus);
      callback('success');
    });
  }, []);
  useEffect(() => {
    const newFackeDate = socketArr.map((item, index) => ({
      elevatorName: item.name,
      elevatorFloor: item.floor,
      elevatorUp: item.direction === 'Up' ? 1 : 0,
      elevatorDown: item.direction === 'Down' ? 1 : 0,
      elevatorDoorStatus: item.door,
      index,
    }));
    setFakeDate(newFackeDate);
  }, [socketArr]);

  //TODO: 電梯左右門狀態
  //電梯開關門左右箭頭動畫

  const elevatorLeftDoor = (item) => {
    if (item.elevatorDoorStatus === 'Unknown') {
      if (elevatorDoorStatus[item.index] === 0) {
        //TODO: 去看前次的的狀態 如果維長閉 代表在開門中；反之關門中
        return <div className={styles.UElevatorarrowsleft} />;
      } else if (elevatorDoorStatus[item.index] === 1) {
        return <div className={styles.UElevatorarrowsright} />;
      }
    } else if (item.elevatorDoorStatus === 'Opened') {
      //TODO: 當狀態維長開時，開門動畫需暫停
      return <div className={styles.UElevatorarrowsleftStop} />;
    } else {
      return <div></div>;
    }
  };
  const elevatorRightDoor = (item) => {
    if (item.elevatorDoorStatus === 'Unknown') {
      if (elevatorDoorStatus[item.index] === 0) {
        return <div className={styles.UElevatorarrowsright} />;
      } else if (elevatorDoorStatus[item.index] === 1) {
        return <div className={styles.UElevatorarrowsleft} />;
      }
    } else if (item.elevatorDoorStatus === 'Opened') {
      return <div className={styles.UElevatorarrowsrightStop} />;
    } else {
      return <div></div>;
    }
  };

  return (
    <div className={styles.mobileElevatorUI}>
      <div className={styles.mobileElevator}>
        <div className={styles.mobileFixBackground} />
        <div className={styles.content}>
          {FakeDate.length === 0 ? (
            <>
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <CircularProgress
                  size="5rem"
                  sx={{
                    marginBottom: '1rem',
                  }}
                />
                <Typography>載入中...</Typography>
              </Box>
            </>
          ) : (
            <>
              {/* TODO: 電梯UI */}
              {FakeDate.map((item, index) => {
                return (
                  <div
                    className={`${styles.ElevatorFrontDesk} ${
                      styles.ElevatorIndex
                    }-${index + 1}`}
                    key={index}
                  >
                    <div className={styles.ElevatorContent}>
                      <div className={styles.title}>{item.elevatorName}</div>
                      <div className={styles.children}>
                        <div className={styles.ElevatorStatus}>
                          <CaretUpOutlined
                            style={{
                              color: item.elevatorUp ? '#69B49E' : '#DDDDDD',
                            }}
                          />
                        </div>
                        <div className={styles.ElevatorFloor}>
                          <div className={styles.ElevatorDoor}>
                            {elevatorLeftDoor(item)}
                          </div>
                          <div className={styles.ElevatorFloorNum}>
                            {item.elevatorFloor}
                          </div>

                          <div className={styles.ElevatorDoor}>
                            {elevatorRightDoor(item)}
                          </div>
                        </div>
                        <div className={styles.ElevatorStatus}>
                          <CaretDownOutlined
                            style={{
                              color: item.elevatorDown ? '#69B49E' : '#DDDDDD',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {/* TODO: 電梯按鈕功能 */}
              <div className={styles.ElevatorBtnGroup}>
                <div
                  className={styles.ElevatorBtn}
                  disabled={elevatorBtnStatus !== ''}
                  style={{
                    backgroundColor:
                      elevatorBtnStatus.upLight === 'on'
                        ? '#69B49E'
                        : '#8b8b8b',
                    pointerEvents:
                      elevatorBtnStatus.upLight === 'on' ||
                      elevatorBtnStatus.downLight === 'on'
                        ? 'none'
                        : 'auto',
                  }}
                  onClick={async () => {
                    const result = await axios(
                      `/ezcon/api/elevator/outerBoard/control`,
                      {
                        method: 'POST',
                        headers: {
                          authorization: window.localStorage['feathers-jwt'],
                        },
                        data: {
                          direction: 'Up',
                        },
                      }
                    );
                    if (result.status === 200) {
                      Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '已幫您叫梯',
                        showConfirmButton: false,
                        timer: 1500,
                      });
                      // setElevatorBtnStatus('Up');
                    }
                    // setTimeout(() => {
                    //   setElevatorBtnStatus('');
                    // }, 20000);
                  }}
                >
                  <CaretUpOutlined />
                </div>
                <div
                  className={styles.ElevatorBtn}
                  disabled={elevatorBtnStatus !== ''}
                  style={{
                    backgroundColor:
                      elevatorBtnStatus.downLight === 'on'
                        ? '#69B49E'
                        : '#8b8b8b',
                    pointerEvents:
                      elevatorBtnStatus.upLight === 'on' ||
                      elevatorBtnStatus.downLight === 'on'
                        ? 'none'
                        : 'auto',
                  }}
                  onClick={async () => {
                    const result = await axios(
                      `/ezcon/api/elevator/outerBoard/control`,
                      {
                        method: 'POST',
                        headers: {
                          authorization: window.localStorage['feathers-jwt'],
                        },
                        data: {
                          direction: 'Down',
                        },
                      }
                    );
                    if (result.status === 200) {
                      Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '已幫您叫梯',
                        showConfirmButton: false,
                        timer: 1500,
                      });
                      // setElevatorBtnStatus('Down');
                    }
                    // setTimeout(() => {
                    //   setElevatorBtnStatus('');
                    // }, 20000);
                  }}
                >
                  <CaretDownOutlined />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ElevatorFrontDesk;
